import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { GeneralService } from 'src/app/Service/general.service';
import Swal from 'sweetalert2';
class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}
@Component({
  selector: 'app-view-epp',
  templateUrl: './view-epp.component.html',
  styleUrls: ['./view-epp.component.scss'],
})
export class ViewEppComponent implements OnInit {
  breadCrumbItems: Array<{}>;
  isdropdownShow: boolean;
  isLoading: boolean;
  param: any ='0';
  date: any = new Date().toISOString().slice(0, 10);
  dtOptions: DataTables.Settings = {};
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtTrigger = new Subject<any>();
  @Input() Type: string;
  myGroup: FormGroup;
  constructor(
    private datepipe: DatePipe,
    private gs: GeneralService,
    private router: Router,
    private renderer: Renderer2,
    private http: HttpClient
  ) {
    this.isdropdownShow = false;
  }

  ngOnInit() {
    
    if(this.Type === 'Current Date') {
      this.param = this.date;
      console.log("date", this.date);
    }
    this.myGroup = new FormGroup({
    date: new FormControl(null),
    });
    this.dtOptions = {  
      // ajax: {
      //   url: `${this.gs.getallEpp()}/${this.param}`,
      // },
      ajax: (dataTablesParameters: any, callback) => {
        this.http
          .get<DataTablesResponse>(
            `${this.gs.getallEpp()}/${this.param}`,
             {}
          ).subscribe(resp => {
            console.log(dataTablesParameters);
            callback({
              data: resp.data
            });
          },(error) => {                              //Error callback
            this.isLoading = false;
            Swal.fire({
              title: error.status,
              text: "Internal Server Error",
              type: "error",
            });
            //throw error;   //You can also throw the error to a global error handler
          });
      },
      responsive: true,
      columns: [
        {
          title: 'Sr.No.',
          data: null,
          render: (data, type, row, meta) => {
            return meta.row + 1;
          },
        },

        {
          title: 'Name',
          data: null,
          render: (data) => {
            return data.FirstName + ' ' + data.LastName;
          },
        },
        {
          title: 'Mobile Number',
          // data: 'MobileNo',
          data: null,
          render: (data) => {
            if(data.MobileNo!=null) {
              const MobileNos = data.MobileNo.split(',');
            var str= `<div>`;
            MobileNos.forEach(element => {
              str = str + `${element} <br>`
            });
            str = str + `</div>`
            return `${str}`;
            }
            return data.MobileNo;
          },
        },
        {
          title: 'Email',
          // data: 'EmailID',
          data: null,
          render: (data) => {
            if(data.EmailID!=null) {
              const EmailIDs = data.EmailID.split(',');
              var str= `<div>`;
              EmailIDs.forEach(element => {
                str = str + `${element} <br>`
              });
              str = str + `</div>`
              return `${str}`;
            }
            return data.EmailID  
          }
        },
        {
          title: 'Active EPP Count',
          data: 'EPPCount',
        },
        {
          title: 'Start Date',
          data: null,
          render: (data) => {
            return this.datepipe.transform(data.start_date, 'MMM, dd yyyy');
          },
        },
        {
          title: 'End Date',
          data: null,
          render: (data) => {
            return this.datepipe.transform(data.end_date, 'MMM, dd yyyy');
          },
        },
        // {
        //   title: 'Status',
        //   data: 'active',
        //   render: (data) => {
        //     if (data === 1) {
        //       return 'Active';
        //     } else {
        //       return 'Inactive';
        //     }
        //   },
        // },
        {
          title: 'Action',
          data: null,
          render(data) {
            return `<div style="display:flex" >
            <a class="ml-1 text-primary plus" title="View This EPP">
            <i class="ml-1 font-18 mdi mdi-plus text-secondary" editEppID="${data.UserID}"></i></a>
            <a class="ml-1 text-primary edit" title="Edit This EPP">
            <i class="ml-1 font-18 mdi mdi-content-save-edit-outline text-secondary" editEppByID="${data.UserID}" ></i></a></div>
            `;
          },
        },
      ],
      drawCallback: () => {
        $('.plus').on('click', (e) => {
          // this.router.navigate(['view/' + e.target.getAttribute('editEppID')]);
          this.router.navigate(['epp/view/' + e.target.getAttribute('editEppID')]);
        });
        $('.edit').on('click', (e) => {
          // this.router.navigate(['view/' + e.target.getAttribute('editEppID')]);
          this.router.navigate([
            'epp/EditById/' + e.target.getAttribute('editEppByID'),
          ]);
        });
      },
      // columnDefs: [{
      //   targets: [2],
      //   visible: true,
      // }]
    };
  }
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }
  ngAfterViewInit() {
    this.dtTrigger.next();
    // this.renderer.listen('document', 'click', (event) => {
    //   if (event.target.hasAttribute('editEppID')) {
    //     // console.log(event.target.getAttribute('editEppID'));
    //     this.router.navigate([
    //       'view/' + event.target.getAttribute('editEppID'),
    //     ]);
    //   }
    // });
  }

  OnDateChange() {
    let newDate = new Date(this.myGroup.controls.date.value);
    this.date = newDate.toISOString().slice(0, 10);
    this.param = this.date;
    console.log(this.param);
    this.rerender();
  }
}
